var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDenienPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99967,
    cy: 10,
    rx: 9.16667,
    ry: 9.16667,
    fill: "#EB5757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5474 13.3333L13.333 12.5477L10.7853 9.99998L13.333 7.45224L12.5474 6.66666L9.99968 9.2144L7.45192 6.66666L6.66634 7.45224L9.21408 9.99998L6.66634 12.5477L7.45192 13.3333L9.99968 10.7856L12.5474 13.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenienPermission);
export default __webpack_public_path__ + "static/media/denien_permission.5f77e357551bdebcf4e6672e75309236.svg";
export { ForwardRef as ReactComponent };